import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ProveedorCreateInterface } from "../../interfaces/proveedorInterfaces/ProveedorCreate.interface";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";
import { useToast } from "vue-toastification";
import { UpdateProveedoroAction } from "../../actions/proveedorActions";

const toast = useToast();

interface UpdateProveedorParams {
  idProveedor: string;
  proveedor: ProveedorCreateInterface;
}

export function useProveedorUpdate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ idProveedor, proveedor }: UpdateProveedorParams) =>
      UpdateProveedoroAction(idProveedor, proveedor),

    onSuccess: async (response: ApiResponse<ProveedorInterface>) => {
      await queryClient.invalidateQueries({ queryKey: ["ProveedoresList"] });
      toast.success("Proveedor actualizado correctamente");
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al actualizar proveedor");
        if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, isSuccess, data }
  };
}
